<app-environment-banner />
<app-loader #loading />
<router-outlet />
<app-base-toast />
